import type { Command, GameState } from "../types/index.js";
import { handleChooseOrganization, handleChooseReward } from "./chooseReward.js";
import {
  handleAdvanceResolution,
  handleEndPhase,
} from "./endPhase.js";
import { handlePlayCard } from "./playCard.js";
import { accept, reject } from "./reject.js";
import { handleSelectNode } from "./selectNode.js";
import { canStartNew, handleBackToTitle, handleOpenBringIn, handleOpenStageSelect } from "./stageSelect.js";
import { handleStartNew } from "./startNew.js";
import { handleSubmitSelection, handleToggleSelection } from "./selection.js";
import { handleRestRemove, handleTakeRest } from "./takeRest.js";
import { handleAcceptEvent, handleDeclineEvent } from "./mapEvent.js";

export function initialGameState(): GameState {
  return {
    screen: "title",
    bringInStageId: null,
    run: null,
    resolution: null,
    activeEvent: null,
    overlay: "none",
    lastRejection: null,
  };
}

export function reduce(state: GameState, command: Command): GameState {
  switch (command.type) {
    case "START_NEW":
      if (!canStartNew(state.screen)) {
        return reject(state, "新規開始はタイトルまたは結果画面からのみ可能");
      }
      return handleStartNew(state, command);
    case "OPEN_STAGE_SELECT":
      return handleOpenStageSelect(state);
    case "OPEN_BRING_IN":
      return handleOpenBringIn(state, command.stageId);
    case "BACK_TO_TITLE":
      return handleBackToTitle(state);
    case "SELECT_NODE":
      return handleSelectNode(state, command);
    case "PLAY_CARD":
      return handlePlayCard(state, command);
    case "TOGGLE_SELECTION":
      return handleToggleSelection(
        state.overlay === "skipFieldJudgmentConfirm" ? { ...state, overlay: "none" } : state,
        command,
      );
    case "SUBMIT_SELECTION":
      return handleSubmitSelection(
        state.overlay === "skipSelectionConfirm" ? { ...state, overlay: "none" } : state,
      );
    case "END_PHASE":
      return handleEndPhase(
        state.overlay === "endPhaseConfirm" ? { ...state, overlay: "none" } : state,
      );
    case "ADVANCE_RESOLUTION":
      return handleAdvanceResolution(state);
    case "CHOOSE_REWARD":
      return handleChooseReward(state, command);
    case "CHOOSE_ORGANIZATION":
      return handleChooseOrganization(state, command);
    case "TAKE_REST":
      return handleTakeRest(state);
    case "REST_REMOVE":
      return handleRestRemove(state, command);
    case "ACCEPT_EVENT":
      return handleAcceptEvent(state);
    case "DECLINE_EVENT":
      return handleDeclineEvent(state);
    case "OPEN_OVERLAY":
      return accept({ ...state, overlay: command.overlay });
    case "CLOSE_OVERLAY":
      return accept({
        ...state,
        overlay: "none",
        run: state.overlay === "phaseTutorial" && state.run
          ? { ...state.run, hasSeenPhaseTutorial: true }
          : state.run,
      });
    case "RESUME":
      return state;
    case "ABANDON_RUN":
      if (state.overlay !== "abandonConfirm") return reject(state, "確認画面からのみゲームをあきらめられる");
      return initialGameState();
    default:
      return state;
  }
}
